import { useDispatch } from 'react-redux';
import { openModal, setModalData } from '~/Redux/Modules/Modal';
import { CONFIRM_DISCONNECT_CALENDAR_ACCOUNT_MODAL } from '~/Config/Modals';

const useConfirmDisconnect = () => {
  const dispatch = useDispatch();

  const confirmDisconnect = opts => {
    const deferred = {};
    const confirmPromise = new Promise((resolve, reject) => {
      deferred.resolve = resolve;
      deferred.reject = reject;
    });
    return new Promise((resolve, reject) => {
      dispatch(openModal(CONFIRM_DISCONNECT_CALENDAR_ACCOUNT_MODAL));
      dispatch(setModalData({ confirmPromise: deferred, ...opts }));
      confirmPromise
        .then(() => {
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  };

  return confirmDisconnect;
};

export default useConfirmDisconnect;
